function BurabaiArticle(props)
{

    return (
        <div className="uk-container uk-margin-top">
            <div>

            {/* Hero Section */}
            <section className="uk-position-relative uk-height-medium uk-background-cover uk-background-center-center" style={{ backgroundImage: 'url(/resort-hero.jpg)' }}>
                <div className="uk-position-center uk-text-center">
                    <h1 className="uk-heading-medium">Experience Luxury Like Never Before</h1>
                    <p className="uk-text-lead">Relax, Explore, and Enjoy with Full Visa Assistance</p>

                    {/* Optional interactive element */}
                    <form className="uk-margin-top uk-flex uk-flex-center" uk-grid="true">
                        <input className="uk-input uk-form-width-large" type="text" placeholder="Check Availability"/>
                        <button className="uk-button uk-button-primary">Go</button>
                    </form>
                </div>
            </section>

            {/* Trust and Credibility */}
            <section className="uk-section uk-section-small">
                <div className="uk-container uk-margin-left uk-margin-right">
                    <h2 className="uk-heading-line"><span>Trusted Services</span></h2>
                    <div className="uk-grid-small uk-child-width-1-3@m" uk-grid="true">
                        <div className="uk-text-center">
                            <span className="uk-icon-button" uk-icon="icon: check; ratio: 2"></span>
                            <p>Visa Assistance</p>
                        </div>
                        <div className="uk-text-center">
                            <span className="uk-icon-button" uk-icon="icon: plane; ratio: 2"></span>
                            <p>Airport Transfers</p>
                        </div>
                        <div className="uk-text-center">
                            <span className="uk-icon-button" uk-icon="icon: star; ratio: 2"></span>
                            <p>Concierge Services</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Emotional Storytelling */}
            <section className="uk-section uk-section-muted">
                <div className="uk-container uk-margin-left uk-margin-right">
                    <h2 className="uk-heading-line"><span>Why Travelers Love It?</span></h2>
                    <p>
                        Nestled in the heart of nature, our resort combines adventure and relaxation. From scenic hiking trails to spa indulgences, experience a lifestyle of unparalleled luxury.
                    </p>
                    <p>
                        Discover what makes this destination unique: gourmet dining, cultural excursions, and exclusive amenities designed to create memories for a lifetime.
                    </p>
                </div>
            </section>

            {/* Practical Information */}
            <section className="uk-section">
                <div className="uk-container uk-margin-left uk-margin-right">
                    <h2 className="uk-heading-line"><span>Practical Information</span></h2>
                    <div className="uk-grid-match uk-child-width-1-2@m uk-grid-small" uk-grid="true">
                        <div>
                            <p>Room Types: Deluxe, Suite, Villa</p>
                            <p>Packages: Weekend Getaway, Family Package, Honeymoon Special</p>
                            <p>Availability: Check online for real-time availability</p>
                        </div>
                        <div>
                            <p>Location: 123 Scenic Road, Paradise Island</p>
                            <p>Nearby Attractions: Coral Beach, Mountain Trails</p>
                            <p>Tips: Best season is May–September</p>
                        </div>
                    </div>
                    <div className="uk-margin-top uk-flex uk-flex-center">
                        <button className="uk-button uk-button-primary uk-margin-small-right">Book Now</button>
                        <button className="uk-button uk-button-default uk-margin-small-right">Check Availability</button>
                        <button className="uk-button uk-button-secondary">Request Visa Assistance</button>
                    </div>
                </div>
            </section>

            {/* Interactive & Visual Enhancements */}
            <section className="uk-section uk-section-muted">
                <div className="uk-container uk-margin-left uk-margin-right">
                    <h2 className="uk-heading-line"><span>Gallery & Experiences</span></h2>
                    <div className="uk-child-width-1-3@m uk-grid-small" uk-grid="true">
                        <div>
                            <div className="uk-inline-clip uk-transition-toggle" tabIndex="0">
                                <img src="/imgvideo/burabai_1.jpg" alt="Gallery 1"/>
                                <div className="uk-transition-slide-bottom uk-position-bottom uk-overlay uk-overlay-default uk-padding-small">
                                    <p>Beach View</p>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="uk-inline-clip uk-transition-toggle" tabIndex="0">
                                <img src="/imgvideo/burabai_2.jpg" alt="Gallery 2"/>
                                <div className="uk-transition-slide-bottom uk-position-bottom uk-overlay uk-overlay-default uk-padding-small">
                                    <p>Mountain Trails</p>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="uk-inline-clip uk-transition-toggle" tabIndex="0">
                                <img src="/imgvideo/burabai_3.jpg" alt="Gallery 3"/>
                                <div className="uk-transition-slide-bottom uk-position-bottom uk-overlay uk-overlay-default uk-padding-small">
                                    <p>Spa & Wellness</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Lead Generation */}
            <section className="uk-section">
                <div className="uk-container uk-text-center">
                    <h2 className="uk-heading-line"><span>Stay Updated</span></h2>
                    <p>Subscribe to our newsletter for the latest packages and offers</p>
                    <form className="uk-margin-top uk-flex uk-flex-center" uk-grid="true">
                        <input className="uk-input uk-form-width-large" type="email" placeholder="Enter your email"/>
                        <button className="uk-button uk-button-primary">Subscribe</button>
                    </form>
                </div>
            </section>

            {/* Conversion Optimization / Social Proof */}
            <section className="uk-section uk-section-muted">
                <div className="uk-container uk-text-center">
                    <h2 className="uk-heading-line"><span>Book Your Stay</span></h2>
                    <p>Hurry! Limited rooms available this season.</p>
                    <div>
                        <button className="uk-button uk-button-primary uk-margin-small-right">Book Now</button>
                        <button className="uk-button uk-button-default">Contact Us</button>
                    </div>
                </div>
            </section>

        </div>
        </div>
    );
}

export default BurabaiArticle;
